import { useSubscriptionStore } from '@entities/subscription'
import { trackEvent } from '@shared/lib/amplitude'

interface UseModalRetrySuccessReturn {
  name: string
  title: ComputedRef<string>
  btnText: string
  setSubmit: () => void
  setClose: () => void
}

export const useModalRetrySuccess = (): UseModalRetrySuccessReturn => {
  const subscriptionStore = useSubscriptionStore()

  const name = 'retry_payment_success'
  const btnText = 'Got it'

  const title = computed<string>(() => {
    const id = subscriptionStore.getPaymentRetrySubscriptionId
    const value = id ? `#${id}` : ''
    return `Subscription ${value} renewed successfully!`
  })

  onMounted(() => {
    // No subscription_id: the retry data is cleared as the modal opens; Payment_success right before carries it
    trackEvent('Popup_view', {
      feature: 'subscription',
      name,
      text: 'Subscription renewed successfully!',
    })
  })

  const setSubmit = (): void => {
    trackEvent('Popup_close', { feature: 'subscription', name, value: 'got_it', text: btnText })
    subscriptionStore.setModalPaymentRetrySuccess(false)
  }

  const setClose = (): void => {
    trackEvent('Popup_close', { feature: 'subscription', name, value: 'close_button' })
    subscriptionStore.setModalPaymentRetrySuccess(false)
  }

  return {
    name,
    title,
    btnText,
    setSubmit,
    setClose,
  }
}
